// `/` — redirects to /support if authenticated, /login otherwise.
import { Navigate } from 'react-router';
import { useAuth } from '../lib/auth';

export function IndexRoute(): React.ReactNode {
  const { status } = useAuth();
  if (status === 'loading') {
    return (
      <main
        id="main-content"
        tabIndex={-1}
        role="status"
        aria-live="polite"
        className="flex min-h-screen items-center justify-center bg-cream text-text-muted focus:outline-none"
      >
        Loading…
      </main>
    );
  }
  if (status === 'authenticated') return <Navigate to="/support" replace />;
  if (status === 'unprovisioned') return <Navigate to="/not-provisioned" replace />;
  return <Navigate to="/login" replace />;
}
